module.exports = __webpack_public_path__ + "img/values.a12a21c8.png";